import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("article", { class: "flex flex-col justify-start items-start w-full px-8 py-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-[16px] font-bold" }, "Gráfico de dividendos")
], -1)
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row w-full py-[3%] px-8 justify-between items-center gap-8"
}
const _hoisted_3 = { class: "flex w-full" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col w-full items-center justify-center gap-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-button-green" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "font-medium text-gray-500" }, "Cargando...", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

import { computed, ref, watch, onMounted } from "vue";
import { ChartService } from "../../services/charts/chartService";
import {
  MonthlyFullInfo,
  MonthlyInfoRequestData,
  FilterType,
} from "../../services/charts/types";

import { Response } from "./types";

import ChartDivComponent from "../atoms/ChartDivComponent.vue";
import ComponentCard from "../atoms/ComponentCard.vue";
import TotalBalanceCard from "../molecules/TotalBalanceCard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChartSection',
  props: {
  filterType: {
    type: Number || undefined,
    default: 0,
    required: false,
  },
  selectedYr: {
    type: Number || undefined,
    default: undefined,
    required: false,
  },
  activeAcc: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const res = ref<Response<any>>();

const fetchIsOk = computed(() => res.value?.success ?? false);

const filterTypeSelected = computed(() => props.filterType);
const selectedYear = computed(() => props.selectedYr ?? 2023);

const activeAccount = computed(() => props.activeAcc);
const dividendsService = new ChartService();

const graphData = ref<MonthlyFullInfo>({
  data: [],
  sumTotalProfitability: 0,
  sumRealProfitability: 0,
  sumTotalClp: 0,
});

const graphDataFiltered = computed(() => {
  if (graphData.value) {
    switch (filterTypeSelected.value) {
      case 0:
        return graphData.value.data;
      case 1:
        return anualDataFilter();
      default:
        return [];
    }
  } else {
    return [];
  }
});

const anualDataFilter = () => {
  let result = graphData.value?.data?.reduce(
    (accumulatorValue: any, currentValue) => {
      if (!accumulatorValue[currentValue.year]) {
        accumulatorValue[currentValue.year] = 0;
      }
      accumulatorValue[currentValue.year] += currentValue.totalClp;
      return accumulatorValue;
    },
    {}
  );
  let typedResult = Object.keys(result).map((year) => {
    return { year: parseInt(year), totalClp: result[year] };
  });
  return typedResult;
};

const getDividend = async () => {
  const dividendsReqAnual = new MonthlyInfoRequestData(
    activeAccount.value,
    filterTypeSelected.value == FilterType.ByConsolidated
      ? getStartDate(2021)
      : getStartDate(selectedYear.value),
    filterTypeSelected.value == FilterType.ByConsolidated
      ? getEndDate(new Date().getFullYear())
      : getEndDate(selectedYear.value)
  );

  res.value = await dividendsService.getDividend(
    activeAccount.value,
    dividendsReqAnual,
    filterTypeSelected.value == FilterType.ByConsolidated
      ? "consolidated"
      : "period"
  );
  graphData.value = res.value.data;
};

function getStartDate(year: number): string {
  const startDate = new Date(year, 0, 1)
    .toISOString()
    .replace("T", " ")
    .replace("Z", "");
  return startDate;
}
function getEndDate(year: number): string {
  const endDate = new Date(year, 11, 30)
    .toISOString()
    .replace("T", " ")
    .replace("Z", "");
  return endDate;
}

watch([selectedYear, activeAccount, filterTypeSelected], () => {
  getDividend();
});

onMounted(() => {
  getDividend();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ComponentCard, { class: "h-full" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TotalBalanceCard, {
          "custom-value": graphData.value?.sumTotalClp,
          "monthly-data": graphData.value,
          "filter-type": _unref(filterTypeSelected)
        }, null, 8, ["custom-value", "monthly-data", "filter-type"])
      ]),
      _hoisted_1,
      (_unref(activeAccount) != 0 && graphData.value && _unref(fetchIsOk))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (graphData.value || _unref(graphDataFiltered))
              ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                  _createElementVNode("article", _hoisted_3, [
                    _createVNode(ChartDivComponent, {
                      title: "",
                      "actions-data": _unref(graphDataFiltered),
                      labeled: false,
                      showYear: _unref(filterTypeSelected) == 1
                    }, null, 8, ["actions-data", "showYear"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
    ]),
    _: 1
  }))
}
}

})